export default {"src":"/_next/static/media/check.f3261c55.svg","height":8,"width":11};